const ShareResult = {
  SHARED: 'shared',
  CANCELLED: 'cancelled',
};

/**
 * Whether the browser can hand this file to the device's share menu. Some in-app browsers can't.
 *
 * @param {File} file
 * @returns {boolean}
 */
const canShareFiles = (file) => !!navigator.canShare?.({ files: [file] });

/**
 * Opens the device's share menu with the file. Call it straight from the tap: browsers only allow sharing
 * while the tap is still being handled.
 *
 * @param {File} file
 * @returns {Promise<string>} A ShareResult. Rejects with any other error than the client closing the menu.
 */
const shareImage = async (file) => {
  try {
    await navigator.share({ files: [file] });
    return ShareResult.SHARED;
  } catch (error) {
    if (error.name === 'AbortError') {
      return ShareResult.CANCELLED;
    }
    throw error;
  }
};

export {
  ShareResult,
  canShareFiles,
  shareImage,
};
